module.exports = __webpack_public_path__ + "img/DSC_1121.b814e43a.jpg";